import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperPlane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"paper-plane, send"} maskId="square-filled-radius-0-stroke-1-IconPaperPlane"><path d="M5.3068 11.5L2.14453 2.01318L22.1186 12.0002L2.14453 21.9873L5.30696 12.5H10.0006V11.5H5.3068Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPaperPlane;
